import { render } from "./campaign-list-modal.vue?vue&type=template&id=3067c9bd"
import script from "./campaign-list-modal.vue?vue&type=script&lang=js"
export * from "./campaign-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__